/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.filters {
    export class BreezeDeleted implements IFilter {
        filter(input:Array<breeze.Entity>, ...args: any[]) {
            if (input == undefined)
                return undefined;
            var x= input.filter(item => {
                return !item.entityAspect.entityState.isDeleted();
            });

            return x;
        }
    }
}

warsApp.registerFilter('BreezeDeleted');